var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "feature-list feature-list--tighter" },
    _vm._l(_vm.features, function(item, i) {
      return _c(
        "li",
        { key: "item" + i },
        [
          _c("Icon", { attrs: { icon: "checkmark" } }),
          _vm._v(" "),
          _c("span", {
            staticClass: "text",
            domProps: { innerHTML: _vm._s(item) }
          })
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }